<template>
  <div class="div_whereabouts">

    <div class="div_block">
      <div class="div_title">
        土地流转去向分析
      </div>
      <div id="landwhereabouts" class="charts"></div>
    </div>

    <div class="div_block div_right">
      <div class="div_title">
        各土地流转模式流转面积分析
      </div>
      <div id="landpatternarea" class="charts"></div>
    </div>

  </div>
</template>

<script>
  import mChart from 'echarts'


  export default {
    name: 'whereabouts',
    data() {
      return {
        chart_whereabouts: null,
        option_whereabouts: null,

        chart_patternarea: null,
        option_patternarea: null,

      }
    },
    mounted() {
      this.initLandWhereabouts();
      this.initLandPatternArea();
    },
    methods: {
      initLandWhereabouts() {
        let self = this;
        if (!this.chart_whereabouts) {
          let myChart = mChart.init(document.getElementById('landwhereabouts'));
          this.chart_whereabouts = myChart;
        }

        this.option_whereabouts = {
          backgroundColor: 'rgba(1,36,34,.9)',
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              lineStyle: {
                color: '#ffbd2e',
                width: 2,
                type: 'dashed',
              }
            },
            borderWidth: 1,
            borderColor: '#009288',
            backgroundColor: 'rgba(0,38,36,0.5)',
            textStyle: {
              color: '#a9adae'
            },
            extraCssText: 'box-shadow: 0 0 1px #00ffee,0 0 1px #00e5ff inset',
            formatter: function (params, ticket, callback) {
              let str = '<span style="color:#ffffff;display:block; width:100%; text-align:center; margin-bottom:4px;">土地流转去向<br/></span>';

              for (let i = 0; i < params.length; i++) {
                if (params[i] !== null) {
                  let v = params[i].value ? params[i].value : 0;
                  str += '<span style="color:#cccccc;">' + params[i].seriesName + '&nbsp:&nbsp&nbsp' + '</span>' + '<span style="color:#46c6ec; ">' + v + '(千公顷)</span>' + '<br/>'
                }
              }
              return str;
            }
          },
          legend: {
            left: 'center',
            top: '18px',
            icon: 'square',
//              itemWidth: 15,
            itemHeight: 10,
            textStyle: {
              color: '#ffffff',
              fontSize: 12
            },
            data: ['流入合作社', '流入农户', '流入企业', '流入专业大户', '流入其他']
          },

          grid: {
            left: '7%',
            right: '4%',
            bottom: '8%',
            top: '50px',
//              containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              nameTextStyle: {
                color: '#ffffff'
              },
              axisTick: {
                alignWithLabel: true,
                show: false
              },
              axisLabel: {
                textStyle: {
                  color: '#666'
                }
              },
              axisLine: {
                lineStyle: {
                  color: '#ffffff',
                  opacity: 0,
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#053d39',
                  type: 'dashed',
                }
              },
              axisTick: {
                show: false,
              },
              data: ['2014', '2015', '2016', '2017', '2018'],
            }
          ],
          yAxis: [
            {
              name: '面积（千公顷）',
              type: 'value',
              nameTextStyle: {
                color: '#8beabb'
              },
//              axisTick: {
//                alignWithLabel: true,
//                show: false
//              },
              axisLabel: {
                textStyle: {
                  color: '#ffffff'
                }
              },
              axisLine: {
                lineStyle: {
                  color: '#ffffff',
                  opacity: 0,
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#053d39',

                }
              },
              axisTick: {
                show: false,
              },
            }
          ],
          color: ['#32a1ec', '#f79728', '#1cdab5', '#5eaefe', '#ebd626', '#438aff'],
          series: [
            {
              name: '流入合作社',
              type: 'line',
              z: 3,
              areaStyle: {
                normal: {
                  color: new mChart.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(50,161,236,.9)'
                  }, {
                    offset: 1,
                    color: 'rgba(50,161,236,.1)'
                  }])

                }
              },
              itemStyle: {
                normal: {
                  color: 'rgba(50,161,236,1)'
                },
              },
              showSymbol: false,
              data: [380, 200, 400, 420, 300]
            },
            {
              name: '流入农户',
              type: 'line',
              z: 2,
              itemStyle: {
                normal: {
                  color: '#f79728',
                }
              },
              areaStyle: {
                normal: {
                  color: new mChart.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0.3,
                    color: 'rgba(247,151,40,.9)'
                  },
                    {
                      offset: 1,
                      color: 'rgba(247,151,40,0)'
                    }])

                }
              },
              showSymbol: false,
              data: [600, 570, 630, 1000, 480]
            },
            {
              name: '流入企业',
              type: 'line',
              z: 1,
              itemStyle: {
                normal: {
                  color: '#1cdab5'
                },
              },
              areaStyle: {
                normal: {
                  color: new mChart.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(28,218,181,1)'
                  },
                    {
                      offset: 0.8,
                      color: 'rgba(28,218,181,.1)'
                    }])

                }
              },
              showSymbol: false,
              data: [780, 900, 820, 1180, 600]
            },
            {
              name: '流入专业大户',
              type: 'line',
              z: 1,
              itemStyle: {
                normal: {
                  color: '#ebd626'
                },
              },
              areaStyle: {
                normal: {
                  color: new mChart.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(235,214,38,.9)'
                  },
                    {
                      offset: 0.8,
                      color: 'rgba(235,214,38,.1)'
                    }])
                }
              },
              showSymbol: false,
              data: [1080, 1200, 1180, 1420, 900]
            },
            {
              name: '流入其他',
              type: 'line',
              z: 1,
              itemStyle: {
                normal: {
                  color: '#3e83f0'
                },
              },
              areaStyle: {
                normal: {
                  color: new mChart.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(62,131,240,1)'
                  },
                    {
                      offset: 0.8,
                      color: 'rgba(62,131,240,0)'
                    }])

                }
              },
              showSymbol: false,
              data: [1320, 1580, 1570, 1720, 1170]
            }
          ]
        };

        this.chart_whereabouts.setOption(this.option_whereabouts);
        window.addEventListener('resize', function () {
          if (self.chart_whereabouts) {
            self.chart_whereabouts.resize();
          }
        })
      },

      initLandPatternArea() {
        let self = this;
        if (!this.chart_patternarea) {
          let myChart = mChart.init(document.getElementById('landpatternarea'));
          this.chart_patternarea = myChart;
        }

        this.option_patternarea = {
          backgroundColor: 'rgba(1,36,34,.9)',
          tooltip: {
            show: true,
            trigger: 'axis',

//            borderWidth: 1,
//            borderColor: '#009288',
//            backgroundColor: 'rgba(0,38,36,0.5)',
//            textStyle: {
//              color: '#a9adae'
//            },
            extraCssText: 'box-shadow: 0 0 1px #00ffee,0 0 1px #00e5ff inset',
            formatter: function (params, ticket, callback) {
              let str = '<span style="color:#ffffff;display:block; width:100%; text-align:center; margin-bottom:4px;">' + params[0].name + '<br/></span>';
              for (let i = 0; i < params.length; i++) {
                if (params[i] !== null) {
                  let v = params[i].value ? params[i].value : 0;
                  str += '<span style="color:#cccccc;">' + params[i].seriesName + '&nbsp:&nbsp&nbsp' + '</span>' + '<span style="color:#46c6ec; ">' + v + '(千公顷)</span>' + '<br/>'
                }
              }
              return str;
            }
          },
          grid: {
            show: true,
//            containLabel: true,
            top: 50,
            bottom: 80,
            right: 13,
            borderColor: 'transparent'
          },
          legend: {
            show: false,
            top: 40,
            right: 20,
            textStyle: {
              fontSize: 12,
              color: '#ffffff',
            },
            itemWidth: 14,
            itemHeight: 6,
            data: ['流转面积']
          },

//          calculable: true,
          xAxis: [
            {
//              name: '纳税额\n(万元)',
              type: 'category',
//              boundaryGap: false,      //   边界是否有缝隙
              data: ['农村土地互换', '农村土地出租', '农村土地股份合作', '农村土地入股', '农村土地转包', '宅基地换住房承包地换社保'],

              axisLabel: {
                interval: 0,
                textStyle: {
                  fontSize: 12,
                  color: '#ffffff',
                },
                formatter: function (params) {
                  if (params && params.length > 4) {
                    let result = '';
                    let count = 1;
                    for (let i = 0; i < params.length; i++) {
                      result += params[i];
                      if (count === 4) {
                        result += '\n';
                        count = 1;
                      }
                      else {
                        count++;
                      }
                    }
                    return result;
                  }
                  else {
                    return params;
                  }
                }
              },
              axisLine: {
                lineStyle: {
                  color: '#ffffff',
                  opacity: 0,
//                  width: 2
                }
              },
              axisTick: {
                show: false,
              },
              axisPointer: {
                type: 'shadow',
                shadowStyle: {
                  color: 'rgba(255,255,255,0.1)',
                }
              },
            }
          ],
          yAxis: [
            {
//                max: 120,
//                interval: 20,
              type: 'value',
              name: '面积（千公顷）',
              nameTextStyle: {
                color: '#8beabb'
              },
              min: 0,
              axisLabel: {
                show: true,
                textStyle: {
                  fontSize: 12,
                  color: '#ffffff'
                }
              },
              axisLine: {
                lineStyle: {
                  color: '#ffffff',
                  opacity: 0,
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  // 使用深浅的间隔色
                  color: '#0c625c',
                  type: 'solid',
                }
              },
              axisTick: {
                show: false,
              },
            }
          ],
//          color: ["#0f7bda", "#e3690e"],
          series: [
            {
              name: '流转面积',
              type: 'bar',
              barWidth: 20,
              data: [480, 440, 420, 380, 300, 480],
              itemStyle: {
                normal: {
                  color: 'rgba(67,210,225,.5)',
                  borderColor: '#00daaf'
                },
              }
            },
          ]
        };

        this.chart_patternarea.setOption(this.option_patternarea);
        window.addEventListener('resize', function () {
          self.chart_patternarea.resize();
        })
      },
    }
  }
</script>

<style lang="scss" scoped>

  .div_whereabouts {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .div_block {
      width: calc((100% - 20px) / 2);
      height: 433px;
      background-color: #002624;
      border: solid 1px rgba(0, 255, 238, 0.5);
      box-sizing: border-box;
      .charts {
        width: 100%;
        height: calc(100% - 30px);
      }
      .div_title {
        height: 30px;
        width: 100%;
        font-size: 14px;
        line-height: 30px;
        background-image: linear-gradient(79deg, rgba(0, 255, 238, 0.5) 0%, rgba(0, 243, 247, 0.4) 25%, rgba(0, 230, 255, 0.3) 50%, rgba(0, 230, 255, 0.1) 100%);
        background-blend-mode: normal, normal;
        box-sizing: border-box;
        padding-left: 12px;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/transaction/whereabouts.vue